import { purchaseOrderStatusName } from '../constants/purchase-order-status.js';
const EXPECTED_DELIVERY_EDITABLE_STATUS_NAMES = new Set([
    purchaseOrderStatusName.DRAFT,
    purchaseOrderStatusName.ISSUED,
    purchaseOrderStatusName.SHIPPED,
    purchaseOrderStatusName.PARTIALLY_RECEIVED,
]);
export function canEditPurchaseOrderExpectedDelivery(statusName) {
    return statusName != null && EXPECTED_DELIVERY_EDITABLE_STATUS_NAMES.has(statusName);
}
//# sourceMappingURL=can-edit-purchase-order-expected-delivery.js.map